/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Blog_Count_OtherInputs */

const en_blog_count_other = /** @type {(inputs: Blog_Count_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} articles`)
};

const lv_blog_count_other = /** @type {(inputs: Blog_Count_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} raksti`)
};

/**
* | output |
* | --- |
* | "{count} articles" |
*
* @param {Blog_Count_OtherInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const blog_count_other = /** @type {((inputs: Blog_Count_OtherInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Count_OtherInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_blog_count_other(inputs)
	return en_blog_count_other(inputs)
});